// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.severity-counts-list-item {
  min-height: 45px;
}

.severity-counts-list-item--clickable {
  cursor: pointer;
}

.severity-counts-list-item--clickable:hover {
  background: var(--lightgray-d);
}

.severity-counts-list-item__name {
  border-bottom: 1px solid #c8c8c8;
  align-items: center;
  min-height: 45px;
  padding-bottom: 5px;
  display: flex;
}

.severity-counts {
  align-items: flex-end;
  display: flex;
}

.severity-counts__severity {
  text-align: center;
  border-bottom-style: solid;
  border-bottom-width: 2px;
  flex: 1 0 30px;
  min-width: 30px;
  padding-bottom: 5px;
  font-size: 10px;
  font-weight: bold;
}

.severity-counts__severity:not(:first-child) {
  margin-left: 1px;
}

.severity-counts__severity--0 {
  border-color: var(--severity-color-0);
}

.severity-counts__severity--10 {
  border-color: var(--severity-color-10);
}

.severity-counts__severity--20 {
  border-color: var(--severity-color-20);
}

.severity-counts__severity--30 {
  border-color: var(--severity-color-30);
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/services/frontend/app/components/SeverityCounts/styles.css","webpack://./services/frontend/app/components/SeverityCounts/styles.css"],"names":[],"mappings":"AADA;ECEE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,wBAAwB;EACxB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;AACxC","sourcesContent":[".severity-counts-list-item {\n  min-height: 45px;\n}\n\n.severity-counts-list-item--clickable {\n  cursor: pointer;\n}\n\n.severity-counts-list-item--clickable:hover {\n    background: var(--lightgray-d);\n  }\n\n.severity-counts-list-item__name {\n  display: flex;\n  align-items: center;\n  min-height: 45px;\n  border-bottom: 1px solid #c8c8c8;\n  padding-bottom: 5px;\n}\n\n.severity-counts {\n  display: flex;\n  align-items: flex-end;\n}\n\n.severity-counts__severity {\n  flex: 1 0 30px;\n  min-width: 30px;\n  border-bottom-width: 2px;\n  border-bottom-style: solid;\n  font-size: 10px;\n  font-weight: bold;\n  text-align: center;\n  padding-bottom: 5px;\n}\n\n.severity-counts__severity:not(:first-child) {\n    margin-left: 1px;\n  }\n\n.severity-counts__severity--0 {\n  border-color: var(--severity-color-0);\n}\n\n.severity-counts__severity--10 {\n  border-color: var(--severity-color-10);\n}\n\n.severity-counts__severity--20 {\n  border-color: var(--severity-color-20);\n}\n\n.severity-counts__severity--30 {\n  border-color: var(--severity-color-30);\n}\n",".severity-counts-list-item {\n  min-height: 45px;\n}\n\n.severity-counts-list-item--clickable {\n  cursor: pointer;\n}\n\n.severity-counts-list-item--clickable:hover {\n  background: var(--lightgray-d);\n}\n\n.severity-counts-list-item__name {\n  border-bottom: 1px solid #c8c8c8;\n  align-items: center;\n  min-height: 45px;\n  padding-bottom: 5px;\n  display: flex;\n}\n\n.severity-counts {\n  align-items: flex-end;\n  display: flex;\n}\n\n.severity-counts__severity {\n  text-align: center;\n  border-bottom-style: solid;\n  border-bottom-width: 2px;\n  flex: 1 0 30px;\n  min-width: 30px;\n  padding-bottom: 5px;\n  font-size: 10px;\n  font-weight: bold;\n}\n\n.severity-counts__severity:not(:first-child) {\n  margin-left: 1px;\n}\n\n.severity-counts__severity--0 {\n  border-color: var(--severity-color-0);\n}\n\n.severity-counts__severity--10 {\n  border-color: var(--severity-color-10);\n}\n\n.severity-counts__severity--20 {\n  border-color: var(--severity-color-20);\n}\n\n.severity-counts__severity--30 {\n  border-color: var(--severity-color-30);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
